import { Component, OnInit } from '@angular/core';
import { ChannelN } from '../../models/channel.model';
import { ObjectNames } from '../../constants/object.names';
import { PermissionService } from 'src/app/service/permission.service';
import { SharedChannelService } from '../../services/channel.service';
import { Subject, takeUntil } from 'rxjs';
import { AccountModuleId } from '../../constants/modules.constant';
import { AccountingService } from 'src/app/configurations/integration/accounting/accounting.service';
import { AppMainService } from 'src/app/app-main.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-pos-stored',
  templateUrl: './pos-stored.component.html',
  styleUrls: ['./pos-stored.component.scss']
})
export class PosStoredComponent implements OnInit {

  totalRecord: number = 0;
  pageNumber: number = 1;
  pageSize: number = 15;
  first: number = 0;
  rowsPerPage = [15, 30, 50, 100];

  product = [];
  posConsumerId :number = 0;
  vendorName :string = "";
  selectedChannelN:any = null;
  channelId:number = 0;;
  channelsN: ChannelN[] = []; 
  selectedProduct;
  noPosDetailsFindOrLoadingText: string = 'Loading...';
  private ngUnsubscribe = new Subject<void>();
  displayAccountViewEdit : boolean = false;
  selectedAccountId: number;
  selectedAccountChannelId: number;
  isAccountView : boolean = false;

  selectedData = null;
  cols = [];

  selectedView = "list";
  isShowSideBtn = true;

  constructor( 
    private messageService: MessageService,
        private sharedChannelService: SharedChannelService,public appMainService: AppMainService,
        private permissionService: PermissionService, private integratonService: AccountingService,) { }

  ngOnInit(): void {
     this.getCols()
     this.getChannels();
  }

  getChannels(): void {
    this.appMainService.isShowSpinner('channels');
    this.sharedChannelService.getChannels(AccountModuleId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
            {
                next: (response) => {
                this.appMainService.isHideSpinner('channels');
                    const channels = response || [];
                    this.channelsN = this.permissionService.filterChannelsByPermissions(channels, ObjectNames.ACCOUNT);
                    this.selectedChannelN = this.channelsN.find(ele=>ele.isDefault) 
                    this.getB2BGroups(this.selectedChannelN?.id)
                },
                error: (error) => {
                  this.product = [];
                  this.appMainService.isHideSpinner('channels');
                 return this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong.' });
                },
                complete: () => {
                this.appMainService.isHideSpinner('channels');
                },
            });
}

getCols(){
 this.cols = 
 [
  {header : "Account Name",field :"accountName"},
  {header : "Account ID",field :"accountId"},
  {header : "Account Address",field :"accountAddress"},
  // {header : "Store ID",field :"storeId"},
  {header : "Store Name",field :"storeName"},
  {header : "Store Address",field :"storeAddress"}
];
}
getData1(event) {
  this.pageNumber = event.first / event.rows + 1;
  this.pageSize = event.rows;
  this.first = event.first;
  this.getListingDetails(this.vendorName,this.posConsumerId,this.selectedChannelN?.id)
}

  changeChannel(e): void {
    this.selectedView='list'
    this.getB2BGroups(this.selectedChannelN?.id);
}

onAccount(e){
this.isAccountView = true
this.selectedAccountId = e.id;
this.selectedAccountChannelId  = this.selectedChannelN?.id;
this.displayAccountViewEdit = true;
}


closeAccountViewEditModal() {
  this.isAccountView = false;
  this.displayAccountViewEdit = false;
  this.selectedAccountId = 0;
  this.selectedAccountChannelId = 0;
}

getB2BGroups(channelId){
  this.integratonService.getB2BGroups().subscribe({
    next: (response) => {
      this.appMainService.isHideSpinner('PosListing');
      this.posConsumerId = response[0]?.posConsumerId;
      this.vendorName = response[0]?.posVendorName;
      this.getListingDetails(this.vendorName,this.posConsumerId,channelId)
    },
    error: (error) => {
      this.appMainService.isHideSpinner('PosListing');
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong.' });
    },
    complete: () => {
      this.appMainService.isHideSpinner('PosListing');
    }
  });
}

getListingDetails(vendorName,posConsumerId,channelId){
  this.appMainService.isShowSpinner('posListing');
  this.integratonService.getListingDetails(vendorName,posConsumerId, channelId,this.pageNumber,this.pageSize).subscribe({
  next: (response) => {
    this.getCols();
       let { posVendorList, headers } = response;
      posVendorList = !posVendorList ? [] : posVendorList;
      headers = !headers  ? [] : headers;
       this.totalRecord = headers["TotalCount"];
       this.product = [];
       if (this.totalRecord > 0) {
    
      this.product = response.posVendorList.accountDetails.map(item => {
        const accountAddress = [
            item.accountAddress.address1,
            item.accountAddress.address2,
            item.accountAddress.city,
            item.accountAddress.state,
            item.accountAddress.country,
            item.accountAddress.zipCode
        ].filter(address => address !== "").join(", ");
        const newItem = {
            ...item,
            accountAddress
        };
        
        newItem.storeName = item.posStoreInfo.storeName;
        newItem.storeId = item.posStoreInfo.storeId;
        newItem.storeAddress = [item.posStoreInfo.address1,item.posStoreInfo.address2,item.posStoreInfo.city,
          item.posStoreInfo.state,
          item.posStoreInfo.zipCode].filter(address => address !== "").join(", ");

      item.posCustomFields.forEach(field => {
        if (newItem.hasOwnProperty(field.name)) {
            newItem[field.name] += `, ${field.value}`;
        } else {
            newItem[field.name] = field.value;
        }
    });

        return newItem;
    });
    
      const addedFields = {}; 
      response.posVendorList.accountDetails.forEach(item => {
          item.posCustomFields.forEach(field => {
              if (!addedFields[field.name]) {
                  this.cols.push({
                      header: field.name,
                      field: field.name 
                  });
                  addedFields[field.name] = true;
              }
          });
      });


         this.appMainService.isHideSpinner('posListing');
       } else {
         this.noPosDetailsFindOrLoadingText = "No Pos Found.";
         this.product = [];
         this.appMainService.isHideSpinner('posListing');
       }
  },
  error: (error) => {
    this.product = [];
    this.totalRecord = 0;
    this.pageNumber = 1;
    this.pageSize= 15;
    this.appMainService.isHideSpinner('posListing');
    return this.messageService.add({ severity: 'error', summary: 'Error', detail: `${error.error.message}` });
  },
  complete: () => {
    this.appMainService.isHideSpinner('posListing');
  }
});
}

  onRowSelect(e) {
    if(!this.isAccountView){
    this.isShowSideBtn = false;
    this.selectedView = "split";
    }
  }

  backListView() {
    this.isShowSideBtn = true;
    this.selectedView = "list";
    this.selectedData = null;
  }
}
